import { TextField as MuiTextField } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useFormContext } from '../../contexts/FormContext';
import { useFormData } from '../../hooks/useFormValues';

const ArrayField = ({ field, getYearlyDaysFromDate }: { field: any; getYearlyDaysFromDate: any }) => {
  const { getFormDataItem, handleChange } = useFormContext();
  const formData = useFormData();

  return (
    <Grid size={field.size || 12} key={field.name}>
      <MuiTextField
        label={field.label}
        fullWidth
        required={field.required || false}
        disabled={field.hasOwnProperty('disabled') ? getFormDataItem(formData, field?.disabled) : false}
        type={field.type}
        name={field.name}
        value={getFormDataItem(formData, field.name) ? getYearlyDaysFromDate(getFormDataItem(formData, field.name)) : []}
        onChange={(e: any) =>
          handleChange({ target: { name: e.target.name, value: e.target.value, type: field.type, checked: e.target.checked } }, field)
        }
      />
    </Grid>
  );
};

export default ArrayField;
